/// Tabs in the classic feedback viewer interface
export enum FeedbackTabId {
  IndividualReport = "individual",
  GroupReport = "group",
  PeerEvaluation = "peer",
}
